const Home = '/';
const FilterResidential = `${Home}filterResidential`;
const FilterPatrimonial = `${Home}filterPatrimonial`;
const Residential = `${Home}residential/:page`;
const ItemResidential = `${Home}residentialItem/:id`;
const Patrimonial = `${Home}patrimonial/:page`;
const ItemPatrimonial = `${Home}patrimonialItem/:id`;
const Team = `${Home}team`;
const Contact = `${Home}contact`;
const Contextual = `${Home}contextual`
const Fail = `${Home}error`;
const Costa = `${Home}costa/:page`;
const Singular = `${Home}singular/:page`;
const Rustico = `${Home}rustico/:page`;
const RefItem = `${Home}reference/:id`;
const Aviso = `${Home}aviso-legal`;
const Politica = `${Home}politica-privacidad`;

const route = {
    Home,
    FilterResidential,
    FilterPatrimonial,
    Residential,
    ItemResidential,
    Patrimonial,
    ItemPatrimonial,
    Team,
    Contact,
    Fail,
    Contextual,
    Costa,
    Singular,
    Rustico,
    RefItem,
    Aviso,
    Politica
}

export default route;